
import { ReactNode } from "react";

interface HeadingProps {
  children: ReactNode;
}

const Heading = ({ children }: HeadingProps) => {
  return (
    <div className="font-semibold text-base mt-3 mb-1">{children}</div>
  );
};

export default Heading;
